module.exports = __webpack_public_path__ + "img/4373298_alipay_logo_logos_icon.260cf47.svg";